import { Typography, Tooltip, Info, RadioButton } from '@weareopenr/component-library';
import classNames from 'classnames/bind';
import { IMealtime } from 'src/types/mealtimes.types';
import styles from './MealtimesView.module.scss';
import { FieldValues, UseFormRegister } from 'react-hook-form';

interface IMealtimesView {
  register: UseFormRegister<FieldValues>;
  filteredMealtimes: IMealtime[];
  mealtimes: IMealtime[];
}

const cx = classNames.bind(styles);

const MealtimesView = ({ filteredMealtimes, mealtimes, register }: IMealtimesView) => {
  return (
    <section>
      <div className={styles['header']}>
        <div className={styles['title']}>
          <Typography weight="semi-bold" size="xxlarge">
            Mealtimes
          </Typography>
          <Tooltip text="When enabled, Openr will create and publish separate menus for each mealtime. Only menu categories that have been assigned to a Mealtime will be published. When disabled all categories will be published using the venue's default opening times.">
            <Info />
          </Tooltip>
        </div>
        <Typography>Use Mealtimes to publish multiple menus for different times of the day.</Typography>
      </div>
      <div className={styles['options']}>
        <RadioButton register={register} name="mealtimes" value="enabled" disabled={!filteredMealtimes.length}>
          <div
            className={cx('option', {
              'option-is-disabled': !filteredMealtimes.length,
            })}
          >
            <Typography>Enable Mealtimes (Mealtimes availability)</Typography>
            {!mealtimes.length && <Typography>The menu does not contain Mealtimes</Typography>}
            {!!mealtimes.length && !filteredMealtimes.length && (
              <Typography>Menu categories have not been assigned to Mealtimes</Typography>
            )}
            {!!mealtimes.length && !!filteredMealtimes.length && (
              <div className={styles['mealtimes']}>
                {filteredMealtimes.map((mealtime: IMealtime) => (
                  <Typography key={mealtime.mealtime_id} size="small" transform="uppercase-first-letter">
                    {mealtime.name}
                  </Typography>
                ))}
              </div>
            )}
          </div>
        </RadioButton>
        <RadioButton register={register} name="mealtimes" value="disabled">
          <Typography>Disable Mealtimes (Default opening hours)</Typography>
        </RadioButton>
      </div>
    </section>
  );
};

export default MealtimesView;
